import type { GrantableRole } from '@/features/auth/types/GrantableRole';
import { apiGet } from '@/services/api';

export const mockAuthApi = {
  roles: () => apiGet<GrantableRole[]>('/mock/roles'),
};
